"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function prepareCombination(opts) {
    return {
        keys: opts.keys.toUpperCase(),
        delay: opts.delay || 250,
        sequence: 0,
        sequenceTimer: null
    };
}
var SPECIAL_EVENT_KEY_MAP = {
    CTRL: "Control",
    ALT: "Alt",
    SHIFT: "Shift",
    WIN: "Meta",
    CMD: "Meta"
};
var KeyBinder = /** @class */ (function () {
    function KeyBinder(options) {
        this.onDocumentKeyDown = this.onDocumentKeyDown.bind(this);
        this.combinations = options.combinations.map(prepareCombination);
        document.addEventListener("keydown", this.onDocumentKeyDown, { passive: true });
    }
    KeyBinder.prototype.onDocumentKeyDown = function (e) {
        var _this = this;
        var matches = this.combinations.filter(function (combination) {
            return _this.checkCombination(e, combination);
        });
        if (matches.length && this.delegate) {
            this.delegate.matchFound(this, matches);
        }
    };
    KeyBinder.prototype.checkCombination = function (event, combination) {
        var _this = this;
        var sequenceParts = combination.keys.split(" + ");
        var isMatchKey = this.isMatchedKey(event, sequenceParts[combination.sequence]);
        if (isMatchKey) {
            if (combination.sequence === sequenceParts.length - 1) {
                this.resetCombination(combination);
                return true;
            }
            combination.sequence++;
            window.clearTimeout(combination.sequenceTimer);
            combination.sequenceTimer = setTimeout(function () {
                _this.resetCombination(combination);
            }, combination.delay);
        }
        return false;
    };
    KeyBinder.prototype.resetCombination = function (combination) {
        window.clearTimeout(combination.sequenceTimer);
        combination.sequenceTimer = null;
        combination.sequence = 0;
    };
    KeyBinder.prototype.isMatchedKey = function (event, key) {
        var specialEventKey = SPECIAL_EVENT_KEY_MAP[key];
        return specialEventKey
            ? event.key === specialEventKey
            : key.charCodeAt(0) === event.which;
    };
    KeyBinder.prototype.destroy = function () {
        document.removeEventListener("keydown", this.onDocumentKeyDown);
    };
    return KeyBinder;
}());
exports.default = KeyBinder;
